/** @format */

import { saveAs } from 'file-saver'

const HEADERS = ['Policy Number', 'Insured', 'Paid Commission', 'Created At']

const escapeCsv = value => {
  const str = value == null ? '' : String(value)
  if (/[",\n]/.test(str)) return `"${str.replace(/"/g, '""')}"`
  return str
}

export const mapXiangqingRows = details => (
  (Array.isArray(details) ? details : []).map(item => ({
    policyNumber: item.id,
    insured: item.protect_user,
    paidCommission: item.change_moeny,
    createdAt: item.created_at,
  }))
)

export const downloadEarningDetailsCsv = (rows, filename = 'Earning-Records-Details.csv') => {
  const safeRows = Array.isArray(rows) ? rows : []
  const lines = [
    HEADERS.join(','),
    ...safeRows.map(row => [
      row.policyNumber,
      row.insured,
      row.paidCommission,
      row.createdAt,
    ].map(escapeCsv).join(',')),
  ]
  const blob = new Blob([`\uFEFF${lines.join('\n')}`], { type: 'text/csv;charset=utf-8;' })
  saveAs(blob, filename)
}
